import { render } from "./card4.vue?vue&type=template&id=69cee43c&scoped=true"
import script from "./card4.vue?vue&type=script&lang=ts"
export * from "./card4.vue?vue&type=script&lang=ts"

import "./card4.vue?vue&type=style&index=0&id=69cee43c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-69cee43c"

export default script